"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Snowplow } from "../Snowplow.component";
export var CoreSnowplow = function (props) {
    var appId = props.appId, collectionUrl = props.collectionUrl, isEnabledEnv = props.isEnabledEnv;
    var isEnabled = isEnabledEnv === "true";
    return (_jsx(Snowplow, { appId: appId, isEnabled: isEnabled, snowplowCollectionUrl: collectionUrl }));
};
